import React, { useState, useEffect } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import Modal from "react-modal";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { FaTimes } from "react-icons/fa";
import * as Yup from "yup";
import { RxEyeOpen, RxEyeNone } from "react-icons/rx";

import { createUser, editOneUser } from "../../../../helpers/Api";
import useToggle from '../../../../hooks/UseToggle';

const ModalAddUser = ({ 
  modalIsOpen, 
  closeModal, 
  token, 
  userData,
}) => {

  const params = useParams();
  const [passwordShown, setPasswordShown] = useToggle();
  const [isSwitchPassword, setIsSwitchPassword] = useToggle();

  let initialValues = {
    nombre_usuario: userData.length !== 0 ? userData.nombre_usuario : "",
    apellidos: userData.apellidos || "",
    nombre: userData.nombre || "",
    correo: userData.correo || "",
    password: "",
    agencia_aduanal_id: params.id,
    grupos: [
      {
        name: "agencia_aduanal",
      },
    ],
  };
  
  
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      width: "55%",
      height: "78%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "linear-gradient(141.48deg, #DBFBFF -2.31%, #DBE9FF 101.54%)",
      borderRadius: "5px",
      border: "none",
      boxShadow: "0px 11px 30px 12px rgba(0, 0, 0, 0.04)",
    },
    overlay: { zIndex: 1000 },
  };

  const handlerCreateUSer = async (values, resetForm) => {
    try {
      const response = await createUser(values, token);
      if (response) {
        Swal.fire("Exito", "El agente aduanal fue creado con éxito", "success");
        closeModal();
        resetForm();
      }
    } catch (error) {
      const errorAxios = error.response;
      Swal.fire(
        "Oops",
        `Ha surgido un problema al crear el usuario, <br />
          Consejo: ${errorAxios.data[0]}
        `,
        "error"
      );
    }
  };

  const handlerEditOneUser = async (data, resetForm) =>{
    try {
      const response = await editOneUser(userData.id,
        isSwitchPassword ?
        {
          agencia_aduanal_id : data.agencia_aduanal_id,
          apellidos : data.apellidos ,
          grupos: data.grupos,
          nombre: data.nombre,
          correo: data.correo,
          nombre_usuario: data.nombre_usuario ? data.nombre_usuario : userData.nombre_usuario,
          password : data.password,
        }
        :
        {
          agencia_aduanal_id : data.agencia_aduanal_id,
          apellidos : data.apellidos ,
          grupos: data.grupos,
          nombre: data.nombre,
          correo: data.correo,
          nombre_usuario: data.nombre_usuario ? data.nombre_usuario : userData.nombre_usuario,
        }, token)
      if(response){
        Swal.fire("Exito", "El usuario ha sido editado", "success");
        closeModal();
        resetForm();
      }
    } catch (error) {
      Swal.fire(
        "Oops",
        `Ha surgido un problema al guardar los cambios de la solicitud, <br />
          Consejo: ${error.response.data[0]}
        `,
        "error"
      );
    }
  }


  const handlerPauseAgenteAduanal = async (state) => {
    Swal.fire({
      title: `¿Estás seguro de ${!state ? 'reactivar' : 'pausar'} el usuario?`,
      text: "Podrás activarlo y pausarlo cuando así se requiera",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `${!state ? 'Sí reactivar' : 'Sí pausar'}`,
      cancelButtonText: "Regresar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await editOneUser(
            userData.id,
            {
              is_active: state ? false : true,
            },
            token);
          if (response) {
            Swal.fire("Exito", "El agente aduanal se ha pausado ", "success");
            closeModal();
          }
        } catch (error) {
          Swal.fire(
            "Oops",
            "Ha surgido un problema al pausar el agente aduanal",
            "error"
          );
        }
      } 
    });
  };
 
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <div>
        <Formik
          enableReinitialize="true"
          initialValues={initialValues}
          validationSchema={Yup.object().shape({    
            nombre_usuario: Yup.string().required("Campo requerido"),
            nombre: Yup.string().required("Campo requerido"),
            correo: Yup.string().email('Debe de ser un correo válido').required("Campo requerido"),
            apellidos: Yup.string().required("Campo requerido"),
            password: userData.length === 0 && Yup.string().required("Campo requerido"),
          })}
          onSubmit={(values, { resetForm }) => {
              if (userData.length === 0) {
                handlerCreateUSer(values, resetForm);
               } else
                handlerEditOneUser(values, resetForm);
          }}
        >
          {(prop) => (
            <Form>
              <div className="row m-1">
                <div className="col-12  d-flex flex-row-reverse">
                  <button type="button" className="btn" onClick={closeModal}>
                    <FaTimes
                      onClick={closeModal}
                      style={{ color: "#F47777" }}
                    />
                  </button>
                </div>
              </div>
              <div className="row addContainer d-flex justify-content-center">
              <div className="col-10">
                { userData.length !== 0 ?
                <>
                <div className="form-check form-switch mb-2 d-flex justify-content-end">
                  <input 
                    className="form-check-input" 
                    type="checkbox"
                    onChange={e => handlerPauseAgenteAduanal(e.target.checked)}
                    checked={!userData.is_active}
                  />
                  <label className="form-check-label" style={{fontSize: '14px'}} for="flexSwitchCheckChecked">&nbsp;Pausar Usuario</label>
                </div>
                <p className="mb-5">
                  Información del agente aduanal capturada
                </p>
                </>
                :
                <p className="mb-5">
                  Ingresa la información requerida para crear usuarios de la agencia aduanal
                </p>
                }
              </div>
              <div className="col-10">
                <label className="form-label">Nombre(s)</label>
                <Field
                  type="text"
                  name="nombre"
                  className="form-control"
                />
                 <ErrorMessage name="nombre" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
              </div>
              <div className="col-10">
                <label className="form-label">Apellidos</label>
                <Field
                  type="text"
                  name="apellidos"
                  className="form-control"
                />
                 <ErrorMessage name="apellidos" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
              </div>
              <div className="col-10">
                <label className="form-label">Nombre de usuario</label>
                <Field
                  type="text"
                  name="nombre_usuario"
                  className="form-control"
                />
                 <ErrorMessage name="nombre_usuario" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
              </div>
              <div className="col-10">
                <label className="form-label">Correo electrónico</label>
                <Field
                  type="text"
                  name="correo"
                  className="form-control"
                />
                 <ErrorMessage name="correo" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
              </div>
              { userData.length !== 0 &&
              <div className="col-10">
                <div className="form-check">
                  <input 
                  className="form-check-input" 
                  type="checkbox" 
                  onClick={setIsSwitchPassword} 
                  />
                  <label className="form-check-label" style={{fontSize: '14px'}} for="flexSwitchCheckChecked">Habilitar cambio de contraseña</label>
                </div>
              </div>
              }
              <div className="col-10">
               <div className="input-group">
                  <label htmlFor="password" className="input-group form-label">
                    Contraseña
                  </label>
                  {
                    isSwitchPassword || userData.length === 0 ?
                    <Field
                      type={passwordShown ? "text" : "password"}
                      name="password"
                      data-toggle="password"
                      className="form-control mb-3"
                      style={{borderRadius: '5px 0px 0px 5px'}}
                    />
                  :
                    <Field
                    name="password"
                    className="form-control mb-3"
                    style={{borderRadius: '5px 0px 0px 5px'}}
                    disabled
                    />
                  }
                <div className="input-group-text mb-3">
                  <i onClick={() => setPasswordShown()}>
                    {passwordShown === false && (
                      <RxEyeNone  />
                    )}
                    {passwordShown === true && (
                      <RxEyeOpen  />
                    )}
                  </i>
                  </div>
              </div>
              <ErrorMessage name="password" component="p" className="requiredField" style={{marginTop: '0.5em'}} />
              </div>
              <div className="d-flex flex-row-reverse cta_solicitud">
                <button
                  type="submit"
                  className="btn"
                  style={{ backgroundColor: "#1F107D", width: "10rem" }}
                >
                  { userData.length === 0 ? 'Crear usuario' : 'Guardar cambios' }
                </button>
              </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default ModalAddUser;
